export default __webpack_public_path__ + "media/course12.cd8fd908.jpg";